import { BORDER_COLORS } from '@constants/colors.ts';
import styled, { css } from 'styled-components';

export const modalForceStyles = {
    mask: {
        background: BORDER_COLORS.blur,
        backdropFilter: 'blur(4px)',
    },
};

export const FOOTER_BTN_STYLE = { width: '50%' };
export const SELECT_ALL_BTN_STYLE = { width: '100%', marginTop: '16px' };

export const ContentWrapper = styled.div`
    padding: 16px 16px 0;
`;

export const TitleWrapper = styled.div`
    padding: 32px 0 0 16px;
`;

export const ScrollWrapper = styled.div`
    position: relative;
    margin-top: 16px;
`;

export const GradientOverlay = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4rem;
    pointer-events: none;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 35.71%, #fff 100%);
`;

export const ListContainer = styled.div<{ $scrollable: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    flex: 1 0 0;
    align-self: stretch;
    margin-bottom: 26px;

    ${({ $scrollable }) =>
        $scrollable
            ? css`
                  max-height: 20rem;
                  overflow-y: auto;
                  overflow-x: hidden;
                  overscroll-behavior: contain;
                  padding-right: 25px;

                  /* WebKit */
                  &::-webkit-scrollbar {
                      width: 6px;
                  }
                  &::-webkit-scrollbar-track {
                      background: ${BORDER_COLORS.primary};
                      border-radius: 48px;
                  }
                  &::-webkit-scrollbar-thumb {
                      background: ${BORDER_COLORS.primary};
                      border-radius: 48px;
                  }

                  /* Firefox */
                  scrollbar-width: thin;
                  scrollbar-color: ${BORDER_COLORS.focus} transparent;
              `
            : css`
                  max-height: none;
                  overflow-y: visible;
              `}
`;

export const ItemRow = styled.div<{ $wasConsentApproved: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-left: 3px;
    background: ${({ $wasConsentApproved }) =>
        $wasConsentApproved ? 'none' : 'var(--colors-surface-warning, #FFFBED)'};
`;
